import { AvatarColors } from "@certn/cascadia/components/avatar/types";
import {
  generateRandomAvatarColour,
  getAvatarColors,
} from "@certn/cascadia/components/avatar/utils";
import { Name, formatName } from "@certn/utils";

import { _Avatar } from "./_Avatar";
import { AvatarBaseProps } from "./types";

type Props = Pick<
  AvatarBaseProps,
  "size" | "testID" | "displayVerifiedBadge"
> & {
  color?: AvatarColors;
  label?: React.ReactNode | string;
  name?: Name;
};

export function TextAvatar(props: Props) {
  const {
    testID = "text-avatar",
    label = props.name ? formatName(props.name, "initials") : "",
    color = generateRandomAvatarColour(props.name),
  } = props;

  const avatarColors = getAvatarColors(color);

  return (
    <_Avatar
      {...props}
      backgroundColor={avatarColors.backgroundColor}
      fontColor={avatarColors.fontColor}
      testID={testID}
    >
      {label}
    </_Avatar>
  );
}
